import * as React from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { useCallback, useState } from 'react'
import { PaymentClosingRequirementsProps } from '../../typings'
import { ClosingPaymentRequirementsModel } from '@user/store/closingRequirements/typings'

import useTheme from '@mui/material/styles/useTheme'
import useMediaQuery from '@mui/material/useMediaQuery'

export const CaptureCardRequirement: React.FC<
  PaymentClosingRequirementsProps
> = (props) => {
  const { onSelected } = props

  const [requirement, setRequirement] =
    useState<ClosingPaymentRequirementsModel>({ ...props })

  const onCheckedUnChecked = useCallback(
    (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      const req = {
        ...requirement,
        [_event?.currentTarget.name]: checked,
      }

      setRequirement(req)
      onSelected(req)
    },
    [requirement, setRequirement, onSelected],
  )
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  const checkboxLabelSx = {
    '& .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium': {
      fontSize: isDesktop ? 24 : 28,
    },
    '& .MuiFormControlLabel-label': {
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    },
  }
  return (
    <>
      <Box display="flex" alignItems="center" mt={2}>
        <Typography variant="h6">
          Sales Funnel: {requirement.salesFunnelName}
        </Typography>
      </Box>
      <Box ml="auto" mb="30px">
        <FormControlLabel
          label="Require card capture to close/win"
          sx={checkboxLabelSx}
          control={
            <Checkbox
              color="primary"
              checked={requirement.requirePayment}
              name="requirePayment"
              onChange={onCheckedUnChecked}
            />
          }
        />
      </Box>
    </>
  )
}
CaptureCardRequirement.displayName = 'CaptureCardRequirement'
